import * as L from 'leaflet';
import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { icon as IconRenderer, layer, text, Icon } from '@fortawesome/fontawesome-svg-core';

export function createBasicLeafletIconButton(icon: IconDefinition, layerText?: string): HTMLAnchorElement {
  const renderedIcon = getRenderedIcon(icon);
  const anchorElement = L.DomUtil.create('a', 'leaflet-btn');
  anchorElement.role = 'button';

  if(layerText) {
    const layeredIcon = layer((push) => {
      push(renderedIcon);
      push(text(layerText));
    });
    console.log(layeredIcon)
    anchorElement.appendChild(layeredIcon.node[0]);
  } else {
    anchorElement.appendChild(renderedIcon.node[0]);
  }


  L.DomEvent.disableScrollPropagation(anchorElement);

  return anchorElement;
}

export function clickOutsideHandler(targets: HTMLElement[], onClickOutsideCb: () => void, container: HTMLElement = document.documentElement) {
  L.DomEvent.on(container, 'click', (event) => {
    if (targets.every(target => !target.contains(event.target as Node))) {
      onClickOutsideCb();
    }
  });
}

export function toggleActiveClass(el: HTMLElement) {
  el.classList.toggle('active');
}

export function getRenderedIcon(icon: IconDefinition): Icon {
  return IconRenderer(icon);
}
